var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import debounce from './utils/debounce';
import transformProperty from './utils/transformProperty';
var ReactSiema = /** @class */ (function (_super) {
    __extends(ReactSiema, _super);
    function ReactSiema(props) {
        var _this = _super.call(this, props) || this;
        _this.events = [
            'onTouchStart',
            'onTouchEnd',
            'onTouchMove',
            'onMouseDown',
            'onMouseUp',
            'onMouseLeave',
            'onMouseMove',
        ];
        _this.config = Object.assign({}, {
            resizeDebounce: 250,
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            threshold: 20,
            loop: false,
            timer: 10000,
            onNext: function () {
                // do nothing.
            },
            onPrev: function () {
                // do nothing.
            },
            onGoTo: function () {
                // do nothing.
            },
        }, props);
        _this.events.forEach(function (handler) {
            _this[handler] = _this[handler].bind(_this);
        });
        _this.currentSlide = 0;
        _this.timer = null;
        _this.selector = React.createRef();
        _this.sliderFrame = React.createRef();
        _this.onResize = function () {
            // do nothing.
        };
        _this.pointerDown = false;
        _this.drag = {
            start: 0,
            end: 0,
        };
        _this.perPage = 0;
        _this.selectorWidth = 0;
        _this.innerElements = [];
        return _this;
    }
    Object.defineProperty(ReactSiema.prototype, "selectorRef", {
        get: function () {
            return this.selector;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactSiema.prototype, "sliderFrameRef", {
        get: function () {
            return this.sliderFrame;
        },
        enumerable: false,
        configurable: true
    });
    ReactSiema.prototype.componentDidMount = function () {
        var _this = this;
        this.config.selector = this.selector;
        this.currentSlide = this.config.startIndex || 0;
        this.init();
        this.onResize = debounce(function () {
            _this.resize();
            _this.slideToCurrent();
        }, this.config.resizeDebounce || 0);
        window.addEventListener('resize', this.onResize);
        if (this.config.draggable) {
            this.pointerDown = false;
            this.drag = {
                start: 0,
                end: 0,
            };
        }
    };
    ReactSiema.prototype.runTimer = function () {
        this.next();
    };
    ReactSiema.prototype.componentDidUpdate = function () {
        if (this.timer)
            clearInterval(this.timer);
        this.init();
    };
    ReactSiema.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
        if (this.timer)
            clearInterval(this.timer);
    };
    ReactSiema.prototype.init = function () {
        var _this = this;
        this.setSelectorWidth();
        this.setInnerElements();
        this.resolveSlidesNumber();
        this.setStyle(this.sliderFrame, {
            width: (this.selectorWidth / this.perPage) * this.innerElements.length + "px",
            webkitTransition: "all " + this.config.duration + "ms " + this.config.easing,
            transition: "all " + this.config.duration + "ms " + this.config.easing,
        });
        for (var i = 0; i < this.innerElements.length; i++) {
            this.setStyleChildren(this.innerElements[i], {
                width: 100 / this.innerElements.length + "%",
            });
        }
        this.slideToCurrent();
        this.timer = setInterval(function () { return _this.runTimer(); }, this.config.timer);
    };
    ReactSiema.prototype.setSelectorWidth = function () {
        if (this.selector)
            this.selectorWidth = this.selectorRef.current.getBoundingClientRect().width;
    };
    ReactSiema.prototype.setInnerElements = function () {
        if (this.sliderFrame)
            this.innerElements = Array.from(this.sliderFrameRef.current.children);
    };
    ReactSiema.prototype.resolveSlidesNumber = function () {
        if (typeof this.config.perPage === 'number') {
            this.perPage = this.config.perPage;
        }
        else if (typeof this.config.perPage === 'object') {
            this.perPage = 1;
            for (var viewport in this.config.perPage) {
                if (window.innerWidth > Number(viewport)) {
                    this.perPage = this.config.perPage[viewport];
                }
            }
        }
    };
    ReactSiema.prototype.prev = function () {
        if (this.currentSlide === 0 && this.config.loop) {
            this.currentSlide = this.innerElements.length - this.perPage;
        }
        else {
            this.currentSlide = Math.max(this.currentSlide - 1, 0);
        }
        this.slideToCurrent();
        if (this.config.onPrev)
            this.config.onPrev(this.currentSlide);
    };
    ReactSiema.prototype.next = function () {
        if (this.currentSlide === this.innerElements.length - this.perPage && this.config.loop) {
            this.currentSlide = 0;
        }
        else {
            this.currentSlide = Math.min(this.currentSlide + 1, this.innerElements.length - this.perPage);
        }
        this.slideToCurrent();
        if (this.config.onNext)
            this.config.onNext(this.currentSlide);
    };
    ReactSiema.prototype.goTo = function (index) {
        this.currentSlide = Math.min(Math.max(index, 0), this.innerElements.length - 1);
        this.slideToCurrent();
        if (this.config.onGoTo)
            this.config.onGoTo(this.currentSlide);
    };
    ReactSiema.prototype.slideToCurrent = function () {
        this.sliderFrameRef.current.style[transformProperty] = "translate3d(-" + this.currentSlide * (this.selectorWidth / this.perPage) + "px, 0, 0)";
    };
    ReactSiema.prototype.updateAfterDrag = function () {
        var movement = this.drag.end - this.drag.start;
        if (movement > 0 && Math.abs(movement) > this.config.threshold) {
            this.prev();
        }
        else if (movement < 0 && Math.abs(movement) > this.config.threshold) {
            this.next();
        }
        this.slideToCurrent();
    };
    ReactSiema.prototype.resize = function () {
        this.resolveSlidesNumber();
        this.selectorWidth = this.selectorRef.current.getBoundingClientRect().width;
        this.setStyle(this.sliderFrame, {
            width: (this.selectorWidth / this.perPage) * this.innerElements.length + "px",
        });
    };
    ReactSiema.prototype.clearDrag = function () {
        this.drag = {
            start: 0,
            end: 0,
        };
    };
    ReactSiema.prototype.setStyle = function (target, styles) {
        var domTarget = target.current;
        Object.keys(styles).forEach(function (attribute) {
            domTarget.style[attribute] = styles[attribute];
        });
    };
    ReactSiema.prototype.setStyleChildren = function (target, styles) {
        Object.keys(styles).forEach(function (attribute) {
            target.style[attribute] = styles[attribute];
        });
    };
    ReactSiema.prototype.onTouchStart = function (e) {
        e.stopPropagation();
        this.pointerDown = true;
        this.drag.start = e.touches[0].pageX;
    };
    ReactSiema.prototype.onTouchEnd = function (e) {
        e.stopPropagation();
        this.pointerDown = false;
        this.setStyle(this.sliderFrame, {
            webkitTransition: "all " + this.config.duration + "ms " + this.config.easing,
            transition: "all " + this.config.duration + "ms " + this.config.easing,
        });
        if (this.drag.end) {
            this.updateAfterDrag();
        }
        this.clearDrag();
    };
    ReactSiema.prototype.onTouchMove = function (e) {
        var _a;
        e.stopPropagation();
        if (this.pointerDown) {
            this.drag.end = e.touches[0].pageX;
            this.setStyle(this.sliderFrame, (_a = {
                    webkitTransition: "all 0ms " + this.config.easing,
                    transition: "all 0ms " + this.config.easing
                },
                _a[transformProperty] = "translate3d(" + (this.currentSlide * (this.selectorWidth / this.perPage) + (this.drag.start - this.drag.end)) * -1 + "px, 0, 0)",
                _a));
        }
    };
    ReactSiema.prototype.onMouseDown = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.pointerDown = true;
        this.drag.start = e.pageX;
    };
    ReactSiema.prototype.onMouseUp = function (e) {
        e.stopPropagation();
        this.pointerDown = false;
        this.setStyle(this.sliderFrame, {
            cursor: '-webkit-grab',
            webkitTransition: "all " + this.config.duration + "ms " + this.config.easing,
            transition: "all " + this.config.duration + "ms " + this.config.easing,
        });
        if (this.drag.end) {
            this.updateAfterDrag();
        }
        this.clearDrag();
    };
    ReactSiema.prototype.onMouseMove = function (e) {
        var _a;
        e.preventDefault();
        if (this.pointerDown) {
            this.drag.end = e.pageX;
            this.setStyle(this.sliderFrame, (_a = {
                    cursor: '-webkit-grabbing',
                    webkitTransition: "all 0ms " + this.config.easing,
                    transition: "all 0ms " + this.config.easing
                },
                _a[transformProperty] = "translate3d(" + (this.currentSlide * (this.selectorWidth / this.perPage) + (this.drag.start - this.drag.end)) * -1 + "px, 0, 0)",
                _a));
        }
    };
    ReactSiema.prototype.onMouseLeave = function (e) {
        if (this.pointerDown) {
            this.pointerDown = false;
            this.drag.end = e.pageX;
            this.setStyle(this.sliderFrame, {
                cursor: '-webkit-grab',
                webkitTransition: "all " + this.config.duration + "ms " + this.config.easing,
                transition: "all " + this.config.duration + "ms " + this.config.easing,
            });
            this.updateAfterDrag();
            this.clearDrag();
        }
    };
    ReactSiema.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", __assign({ ref: this.selector, style: { overflow: 'hidden' } }, this.events.reduce(function (props, event) {
            var _a;
            return Object.assign({}, props, (_a = {}, _a[event] = _this[event], _a));
        }, {})),
            React.createElement("div", { ref: this.sliderFrame }, React.Children.map(this.props.children, function (children, index) {
                return React.cloneElement(children, {
                    key: index,
                    style: { float: 'left' },
                });
            }))));
    };
    return ReactSiema;
}(Component));
export default ReactSiema;
